// extracted by mini-css-extract-plugin
export default {"store-button":"aetGTZ","store-button__img":"kvRrd_","store-button--appStore":"NCpnp0"};